import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { createRoot } from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import history from "./utils/history"; // Import your history module
import { getConfig } from "./config"; // Import your configuration module
import "./index.css";
import App from "./App";

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

const config = getConfig();

const root = createRoot(document.getElementById("root"));

const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: process.env.REACT_APP_FRONTEND_URL,
    ...(config.audience ? { audience: config.audience } : null),
    scope: "openid profile email",
  },
};

root.render(
  <Auth0Provider {...providerConfig}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Auth0Provider>
);
